// React import
import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {setPage} from "../../actions";
// Components imports
import AiCircle from "../AiCircle";
import TokenAnalyzerStat from "../TokenAnalyzerStat";
import TokenAnalyzerSearch from "../TokenAnalyzerSearch";
import TokenAnalyzerTokenAddress from "../TokenAnalyzerTokenAddress";
import TokenAnalyzerMenu from "../TokenAnalyzerMenu";
import TokenAnalyzerWalletStats from "../TokenAnalyzerWalletStats";
import TokenAnalyzerAiStats from "../TokenAnalyzerAiStats";
// Styles imports
import './TokenAnalyzer.css';
import '../../util.css'
// Svg import
import { ReactComponent as DirectUpSvg } from '../../svg-icons/arrow-up.svg';
// Consts imports
import {
    TOKEN_ANALYZER_STATS,
    TOKEN_ANALYZER_WALLETS,
    TOKEN_ANALYZER_AI_STATS,
    TOKEN_ANALYZER_WELCOME,
    AI_TOKEN_ANALYZER_WELCOME,
    LEVEL_FEATURES,
    TOKEN_ANALYZER,
    PAGE_UPGRADE,
    TOKEN_ANALYZER_PROCESSING
} from "../../consts/consts";

function TokenAnalyzerTab(props) {

    const { page } = props;

    if (page === TOKEN_ANALYZER_STATS) {
        return <TokenAnalyzerStat/>
    } else if (page === TOKEN_ANALYZER_WALLETS) {
        return <TokenAnalyzerWalletStats/>
    } else if (page === TOKEN_ANALYZER_AI_STATS) {
        return <TokenAnalyzerAiStats/>
    } else {
        return null
    }

}

function AvailableTitle(props) {

    const { level } = props;

    return (
        <span className={"token-analyzer__block_text_available"}>
            Upgrade to <br/>AI level {level}
        </span>
    );

}

class TokenAnalyzer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {openTab: TOKEN_ANALYZER_STATS};
    }

    handleStatsClick = () => {
        this.setState({openTab: TOKEN_ANALYZER_STATS});
    }

    handleWalletsClick = () => {
        this.setState({openTab: TOKEN_ANALYZER_WALLETS});
    }

    handleAiStatsClick = () => {
        this.setState({openTab: TOKEN_ANALYZER_AI_STATS});
    }

    handleUpgradeClick = () => {
        const { setPage } = this.props;
        setPage(PAGE_UPGRADE);
    };

    render () {

        const { openTab } = this.state;
        const { status } = this.props.tokenAnalyzer;
        const { ai_level } = this.props.userData;

        let aiLevelInt = parseInt(ai_level);

        if ( aiLevelInt < LEVEL_FEATURES[TOKEN_ANALYZER]) {
            return(
                <div className={"token-analyzer"}>
                    <div className={"token-analyzer-item-available noselect"} onClick={this.handleUpgradeClick}>
                        <DirectUpSvg className={"token-analyzer-block-item-icon-direct-up"}/>
                        <AvailableTitle level={LEVEL_FEATURES[TOKEN_ANALYZER]}/>
                    </div>
                </div>
            );
        }

        if(status === TOKEN_ANALYZER_WELCOME || status === TOKEN_ANALYZER_PROCESSING) {
            return(
                <div className={"token-analyzer"}>
                    <TokenAnalyzerSearch/>
                    <AiCircle position={AI_TOKEN_ANALYZER_WELCOME}/>
                </div>
            );
        } else {
            return(
                <div className={"token-analyzer"}>
                    <TokenAnalyzerSearch/>
                    <TokenAnalyzerTokenAddress/>
                    <TokenAnalyzerMenu tab={openTab}
                                       statsClick={this.handleStatsClick} walletsClick={this.handleWalletsClick}
                                       aiStatsClick={this.handleAiStatsClick}/>
                    <TokenAnalyzerTab page={openTab}/>
                </div>
            );
        }
    }
}

const mapStateToProps = ({ tokenAnalyzer, userData }) => {
    return { tokenAnalyzer, userData };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setPage
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TokenAnalyzer);
